import { useTracking } from 'react-tracking';
import { ROUTE_PLANS } from '@/constants/routes';
import { Button } from '@simplywallst/ui-core/next';
import { useUserAccess } from '@/hooks/useUserAccess';
import { useTranslation } from '@/hooks/useTranslation';
import { getPath } from '@/router/utils';
import useUser from '@/hooks/useUser';
import { useFlag } from '@/features/unleash';

export const UpgradeButton = () => {
  const { trackEvent } = useTracking({
    type: 'track',
    subject: 'desktopTopBarUpgrade',
  });
  const t = useTranslation();

  const user = useUser();
  const userAccess = useUserAccess();

  const showUpgradeButtonExperiment =
    useFlag({ name: 'mono-upgrade-button' }).variant.name === 'variant' &&
    RUNTIME_ENV !== 'native' &&
    userAccess.data.planType === 'free' &&
    userAccess.data.provider === 'stripe' &&
    user.data.billing.status !== 'trialing';

  if (!showUpgradeButtonExperiment) return;

  return (
    <Button
      href={getPath({ type: ROUTE_PLANS, payload: {} })}
      size="medium"
      className="self-center"
      data-cy-id="nav-upgrade-btn-desktop"
      onClick={() => {
        trackEvent({ action: 'click' });
      }}
    >
      {t('app.topbar.nav.upgrade')}
    </Button>
  );
};
